module.exports = "https://99designs-start-assets.imgix.net/js/b0a133a5a9ebfe906ac4afda627fac8c.svg";